import React, { Suspense } from 'react'
import { useResponsiveValue } from '@theme-ui/match-media'

import {
  ContactBlockStyled,
  ContactBlockContentStyled,
  ContactBlockFormStyled,
  ContactBlockContentHeadStyled,
  ContactBlockContentHeadTextStyled,
  ContactBlockContentIconsStyled,
  ContactBlockContentSocialStyled,
  ContactBlockContentIconsItemStyled
} from './styles'
import StayConnected from './../../molecules/StayConnected'
import IconText from './../../atoms/IconText'
import { ContactBlockProps } from './types'

const ContactForm = React.lazy(() => import('../ContactForm'))

const ContactBlock: React.FC<ContactBlockProps> = ({ data: { title, isMainHeading, subtitle, mail, chat, social, form } }) => {
  const isTablet = useResponsiveValue([false, true, true, true], {
    defaultIndex: 0
  })

  const headingTemplate = (
    <>
      {title || subtitle ? (
        <ContactBlockContentHeadStyled>
          {title && (
            <ContactBlockContentHeadTextStyled
              as={isMainHeading ? 'h1' : 'h2'}
              sx={{
                color: 'green'
              }}
            >
              {title}
            </ContactBlockContentHeadTextStyled>
          )}
          {subtitle && <ContactBlockContentHeadTextStyled as="p">{subtitle}</ContactBlockContentHeadTextStyled>}
        </ContactBlockContentHeadStyled>
      ) : (
        ''
      )}
    </>
  )

  return (
    <>
      {!isTablet && headingTemplate}
      <ContactBlockStyled>
        <ContactBlockContentStyled>
          {isTablet && headingTemplate}
          {mail || chat ? (
            <ContactBlockContentIconsStyled>
              {chat && (
                <ContactBlockContentIconsItemStyled onClick={chat.onClick}>
                  <IconText title={chat.title} icon={chat.icon} />
                </ContactBlockContentIconsItemStyled>
              )}
              {mail && (
                <ContactBlockContentIconsItemStyled as="a" href={`mailto:${mail.url}`}>
                  <IconText title={mail.title} icon={mail.icon} />
                </ContactBlockContentIconsItemStyled>
              )}
            </ContactBlockContentIconsStyled>
          ) : (
            ''
          )}
          {social && (
            <ContactBlockContentSocialStyled>
              <StayConnected data={social} />
            </ContactBlockContentSocialStyled>
          )}
        </ContactBlockContentStyled>
        {form && typeof window !== 'undefined' && (
          <Suspense fallback={<div />}>
            <ContactBlockFormStyled>
              <ContactForm {...form} />
            </ContactBlockFormStyled>
          </Suspense>
        )}
      </ContactBlockStyled>
    </>
  )
}

export default ContactBlock
